import React from "react";
import { Col } from "react-bootstrap";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { setBuilderColors } from "../../../../redux/slices/linksBuilder";
import { LINK_LIST_COLORS } from "../../../../constants/inputValues";
import { colorPalettes } from "./Design";
import { FrameItem } from "./SocialLinks";

const NoColorPaletteItem = () => {
  const { colors } = useSelector((state) => ({
    colors: state.linksBuilder.data.colors,
  }));
  const dispatch = useDispatch();
  const isPalletteColor = colorPalettes.some(
    (item) =>
      item.background == colors[0] &&
      item.linkBackground == colors[1] &&
      item.textColor == colors[2]
  );

  return (
    <Col xs={2} md={1}>
      <FrameItem
        onClick={() => dispatch(setBuilderColors(LINK_LIST_COLORS))}
        className={classNames(
          "d-flex justify-content-center align-items-center border rounded-1 p-2",
          {
            "border-primary": !isPalletteColor,
            "border-border-gray": isPalletteColor,
          }
        )}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 1.5L38.5 38.5M38.5 1.5L1.5 38.5"
            stroke="#8B929A"
            strokeWidth="2"
          />
        </svg>
      </FrameItem>
    </Col>
  );
};

export default NoColorPaletteItem;
